module.exports = __webpack_public_path__ + "img/time-23.52a75266.svg";